// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-cbx {
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  margin-bottom: 0;
}
.label-cbx input:checked + .checkbox {
  border-color: #20C2E0;
}
.label-cbx input:checked + .checkbox svg path {
  fill: #20C2E0;
}
.label-cbx input:checked + .checkbox svg polyline {
  stroke-dashoffset: 0;
}
.label-cbx:hover .checkbox svg path {
  stroke-dashoffset: 0;
}
.label-cbx .checkbox {
  position: relative;
  top: 2px;
  float: left;
  margin-right: 8px;
  width: 20px;
  height: 20px;
  border: 2px solid #C8CCD4;
  border-radius: 3px;
}
@media (max-width: 490px) {
  .label-cbx .checkbox {
    width: 15px;
    height: 15px;
  }
}
.label-cbx .checkbox svg {
  position: absolute;
  top: -2px;
  left: -2px;
  width: 20px;
  height: 20px;
}
@media (max-width: 490px) {
  .label-cbx .checkbox svg {
    width: 15px;
    height: 15px;
  }
}
.label-cbx .checkbox svg path {
  fill: none;
  stroke: #20C2E0;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 71px;
  stroke-dashoffset: 71px;
  transition: all 0.6s ease;
}
.label-cbx .checkbox svg polyline {
  fill: none;
  stroke: #FFF;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 18px;
  stroke-dashoffset: 18px;
  transition: all 0.3s ease;
}
.label-cbx > span {
  pointer-events: none;
  vertical-align: middle;
}

.invisible {
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/components/Checkbox/style.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,gBAAA;AACJ;AACI;EACE,qBAAA;AACN;AAEQ;EACE,aAAA;AAAV;AAGQ;EACE,oBAAA;AADV;AAOM;EACE,oBAAA;AALR;AASI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAPN;AAQM;EATF;IAUI,WAAA;IACA,YAAA;EALN;AACF;AAOM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AALR;AAMQ;EANF;IAOM,WAAA;IACA,YAAA;EAHV;AACF;AAKQ;EACE,UAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AAHV;AAMQ;EACE,UAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AAJV;AASI;EACE,oBAAA;EACA,sBAAA;AAPN;;AAYE;EACE,kBAAA;AATJ","sourcesContent":[".label-cbx {\n    user-select: none;\n    cursor: pointer;\n    margin-bottom: 0;\n  \n    input:checked + .checkbox {\n      border-color: #20C2E0;\n  \n      svg {\n        path {\n          fill: #20C2E0;\n        }\n  \n        polyline {\n          stroke-dashoffset: 0;\n        }\n      }\n    }\n  \n    &:hover {\n      .checkbox svg path {\n        stroke-dashoffset: 0;\n      }\n    }\n  \n    .checkbox {\n      position: relative;\n      top: 2px;\n      float: left;\n      margin-right: 8px;\n      width: 20px;\n      height: 20px;\n      border: 2px solid #C8CCD4;\n      border-radius: 3px;\n      @media(max-width: 490px) {\n        width: 15px;\n        height: 15px;\n      }\n  \n      svg {\n        position: absolute;\n        top: -2px;\n        left: -2px;\n        width: 20px;\n        height: 20px;\n        @media(max-width: 490px) {\n            width: 15px;\n            height: 15px;\n        }\n  \n        path {\n          fill: none;\n          stroke: #20C2E0;\n          stroke-width: 2;\n          stroke-linecap: round;\n          stroke-linejoin: round;\n          stroke-dasharray: 71px;\n          stroke-dashoffset: 71px;\n          transition: all .6s ease;\n        }\n  \n        polyline {\n          fill: none;\n          stroke: #FFF;\n          stroke-width: 2;\n          stroke-linecap: round;\n          stroke-linejoin: round;\n          stroke-dasharray: 18px;\n          stroke-dashoffset: 18px;\n          transition: all .3s ease;\n        }\n      }\n    }\n  \n    > span {\n      pointer-events: none;\n      vertical-align: middle;\n    }\n  }\n  \n  \n  .invisible {\n    position: absolute;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
